// removed by extract-text-webpack-plugin
module.exports = {"container":"container_ReportBanner"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportBanner/ReportBanner.scss
// module id = 279
// module chunks = 0